import { GlobalToken } from 'antd';
import styled from 'styled-components';

interface ContainerProps {
  width: number;
  height: number;
  $mapView: number;
  $textColor: string;
  theme: { token: GlobalToken };
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  ${({ $mapView, theme: { token } }) => $mapView === 1 && `margin-top: ${token.marginMD}px;`}

  .background {
    position: absolute;
    top: 0;
    left: 0;
    z-index: ${({ $mapView }) => $mapView};
  }

  .title {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ $textColor }) => $textColor};
    text-transform: capitalize;
    position: absolute;
    top: 40px;
    left: 28px;
  }

  header {
    display: flex;
    align-items: flex-end;
    height: ${({ $textColor }) => ($textColor ? '43%' : '33%')};
    padding: ${({ $textColor, theme: { token } }) => ($textColor ? token.marginXXL : token.paddingXL)}px 0px 0px
      ${({ theme: { token } }) => token.paddingMD}px;
  }

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100px;
    padding: ${({ theme: { token } }) => token.paddingXXS}px;

    .capacity-container {
      .value {
        font-size: ${({ theme: { token } }) => token.fontSizeHeading4}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }

      .label {
        margin-left: ${({ theme: { token } }) => token.marginXXS}px;
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }

    .pressure-container {
      .value {
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
        color: ${({ theme: { token } }) => token.colorText};
      }

      .label {
        margin-left: ${({ theme: { token } }) => token.marginXXS}px;
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};
      }
    }
  }
`;
